import React from 'react';

import { Box, Header } from '@rbilabs/universal-components';
import { HeaderProps } from 'ucl/components/header/Header';
import { Typography } from 'ucl/components/text/Typography';

import BlockRenderer from 'components/sanity-block-renderer';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken } from 'styles/constants';

const staticPageHeader2: { [key: string]: HeaderProps } = {
  'terms-conditions-rewards': {
    textAlign: 'left',
  },
};

const staticPageHeader3: { [key: string]: HeaderProps } = {
  'about-bk': {
    textAlign: 'left',
    fontFamily: 'body',
  },
  'terms-of-service': {
    textAlign: 'left',
    fontFamily: 'body',
  },
};

const HeaderCommon = {
  fontWeight: 'light',
  padding: 0,
  paddingTop: '$8',
  margin: 0,
  marginBottom: '$2',
};

export const UnknownWidget = Box;

export const Header1 = Header.withConfig({
  ...HeaderCommon,
  textAlign: 'center',
  variant: 'headerOne',
  fontSize: {
    base: '4xl',
    md: '6xl',
  },
  display: 'flex',
});

export const Header2 = Header.withConfig<{ pageSlug: string }>(p => ({
  ...HeaderCommon,
  textAlign: 'center',
  variant: 'headerTwo',
  fontSize: {
    base: '2xl',
    md: '4xl',
  },
  display: 'flex',
  ...(staticPageHeader2[p.pageSlug] ?? null),
}));

export const Header3 = Header.withConfig<{ pageSlug: string }>(p => ({
  ...HeaderCommon,
  textAlign: 'center',
  variant: 'headerThree',
  fontSize: {
    base: 'lg',
    md: '3xl',
  },
  display: 'flex',
  ...(staticPageHeader3[p.pageSlug] ?? null),
}));

export const Header4 = Header.withConfig({
  ...HeaderCommon,
  variant: 'headerFour',
  fontSize: 'lg',
  display: 'flex',
});

export const Header5 = Header.withConfig({
  ...HeaderCommon,
  variant: 'headerFour',
  fontSize: 'lg',
  display: 'flex',
});

const staticPageParagraph: Record<string, React.ComponentPropsWithoutRef<typeof Typography>> = {
  'about-bk': {
    mt: '$1',
  },
};

export const Paragraph = ({
  pageSlug,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & { pageSlug: string }) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Typography, {
    variant: 'copyOne',
    fontSize: isDesktop ? 'xl' : 'md',
    lineHeight: 'lg',
    mt: '$8',
    ...(staticPageParagraph[pageSlug] ?? {}),
    ...props,
  });
};

export const BlockWidgetContainer = BlockRenderer.withConfig({
  marginBottom: '$6',
  marginX: 'auto',
  width: 'full',
});

export const ListItem = (props: React.ComponentPropsWithoutRef<typeof Typography>) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Typography, {
    variant: 'copyOne',
    fontSize: isDesktop ? 'xl' : 'md',
    lineHeight: 'md',
    mt: '$2',
    ...props,
  });
};

export const blockWidgetStrongProps = {
  lineHeight: 'lg',
};

export const blockWidgetLinkProps = {
  color: getDesignToken('text-link-hover'),
};
